import React from 'react';
import Button from "@mui/material/Button";

import {useDispatch, useSelector} from 'react-redux'
import {getDatabase, ref, get, remove} from "firebase/database";

import { clearUserProfileKeepingCompletions, clearCourseCompletions } from "../../redux/userSlice";
import { resetTeam } from "../../redux/teamSlice";
import { createAlert, resetUi } from "../../redux/uiSlice";
import {coursesKeys} from "../courseContent/courseObjects";
import {messageType} from "../common/RequestAlertBar";
import Typography from "@mui/material/Typography";




const ResetButton = () => {
  const dispatch = useDispatch();
  const uid = useSelector((state) => state.user?.uid);
  const courseCompletions = useSelector((state) => state.user?.courseCompletions) || {};
  const currentTeamId = useSelector((state) => state.team?.currentTeamId);

  async function partialDeleteUserInfo(userId) {
    const db = getDatabase();
    const userRef = ref(db, '/users/' + userId);
    const snapshot = await get(userRef);
    const data = snapshot.val();
    if (!data) {
      dispatch(clearUserProfileKeepingCompletions());
      dispatch(resetTeam());
      dispatch(resetUi());
      dispatch(createAlert({ type: messageType.success, message: 'Data deleted successfully' }));
      return;
    }
    const removePromises = Object.keys(data)
      .filter((key) => key !== 'courseCompletions')
      .map((key) => remove(ref(db, `/users/${userId}/${key}`)));
    try {
      await Promise.all(removePromises);
      dispatch(clearUserProfileKeepingCompletions());
      dispatch(resetTeam());
      dispatch(resetUi());
      dispatch(createAlert({ type: messageType.success, message: 'Data deleted successfully' }));
    } catch (err) {
      dispatch(createAlert({ type: messageType.error, message: err }));
    }
  }

  const clearLeaderboardData = async () => {
    if (!uid) return;
    const db = getDatabase();

    try {
      // 1. Delete leaderboard entries (using teamIds from completions and current team)
      const leaderboardPromises = [];
      for (const [courseKey, data] of Object.entries(courseCompletions)) {
        if (data?.teamId) {
          leaderboardPromises.push(remove(ref(db, `/leaderboard/${courseKey}/${data.teamId}`)));
        }
      }
      if (currentTeamId) {
        for (const courseKey of coursesKeys) {
          leaderboardPromises.push(remove(ref(db, `/leaderboard/${courseKey}/${currentTeamId}`)));
        }
      }
      await Promise.all(leaderboardPromises);

      // 2. After leaderboard entries are removed, delete completion data under uid
      const completionPromises = Object.keys(courseCompletions).map((courseKey) =>
        remove(ref(db, `/users/${uid}/courseCompletions/${courseKey}`))
      );
      await Promise.all(completionPromises);

      dispatch(clearCourseCompletions());
      dispatch(createAlert({ type: messageType.success, message: 'Data deleted successfully' }));
    } catch (err) {
      dispatch(createAlert({ type: messageType.error, message: err }));
    }
  };

  const handleResetUserAnswers = () => {
    partialDeleteUserInfo(uid);
  };

  return (
    <>
      <Button variant={'outlined'} onClick={handleResetUserAnswers} color={'secondary'} style={{margin: '8px 0', width: '100%'}}>Delete my profile data</Button>
      <Typography variant={'caption'}>This removes your profile info from our servers (name, avatar, etc.) and resets the app. You can set up again from scratch.</Typography>

      <Button variant={'outlined'} onClick={clearLeaderboardData} color={'secondary'} style={{margin: '8px 0', marginTop: '24px', width: '100%'}}>Delete my team's
        leaderboard entry(s) </Button>
      <Typography variant={'caption'}>Deleting your leaderboard entries will mean your team name and score no longer appear up on the leaderboard for any courses you may have completed.</Typography>
    </>
  )
};

export default ResetButton